import React, { useState, useEffect } from "react";
import IdentityVaultTab from "../IdentityVaultTab";
import DocumentsAndImages from "../DocumentsAndImages";
import AddWalletDialog from "../../Dialogs/lostWallet/AddWalletDialog";
import Combination from "./Combination";
import CustomerRewardsCard from "./CustomerRewardsCard";
import FamilyAsset from "./FamilyAsset";
import Passport from "./Passport";
import SocialSecurityCard from "./SocialSecurityCard";
import IdCard from "./IdCard";
import MedicalIdCard from "./MedicalIdCard";
import DriversLicense from "./DriversLicense";
import BankAccount from "./BankAccount";
import CreditDebitCard from "./CreditDebitCard";
import { useDispatch, useSelector } from "react-redux";
import * as services from "../../../store/service";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { DialogComponent } from "../../common/DialogComponent";
import SocialSecurityCardDialog from "../../Dialogs/lostWallet/SocialSecurityCardDialog";
import PassportDialog from "../../Dialogs/lostWallet/PassportDialog";
import MedicalIdCardDialog from "../../Dialogs/lostWallet/MedicalIdCardDialog";
import IdCardDialog from "../../Dialogs/lostWallet/IdCardDialog";
import DriverLicenseDialog from "../../Dialogs/lostWallet/DriverLicenseDialog";
import CustomerRewardsCardDialog from "../../Dialogs/lostWallet/CustomerRewardsCardDialog";
import CreditDebitCardDialog from "../../Dialogs/lostWallet/CreditDebitCardDialog";
import CombinationDialog from "../../Dialogs/lostWallet/CombinationDialog";
import BankAccountDialog from "../../Dialogs/lostWallet/BankAccountDialog";
import { useAreServicesAndFeatureActive } from "../../../util/CommonServices";
import { idfServiceIds, ezsServiceIds } from "../../../config/UserServicesList";
import * as Common from "../../../util/common";
import { userLostWalletStateStatePII } from "../../../store/common";
import { useTranslation } from "react-i18next";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

const SecureStorage = (props: any) => {
    const dispatch = useDispatch();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [addWalletDialogIsVisible, setAddWalletDialogIsVisible] = useState(false);
    const [addItemDialogIsVisible, setAddItemDialogIsVisible] = useState(false);
    const [addItemOption, setAddItemOption] = useState("");
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [isLoading, setisLoading] = useState(false);
    const [userLostWallets, setUserLostWallets] = useState({} as userLostWalletStateStatePII);

    const ids = [
        idfServiceIds.lostWalletAssistance,
        ezsServiceIds.idRestorationPro,
        ezsServiceIds.idRestorationProInd,
        ezsServiceIds.idDRestorationProWith1mInsurance,
        ezsServiceIds.idRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationPro,
        ezsServiceIds.familyIdRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationProWith1MInsurance,
        ezsServiceIds.businessIdRestorationPro,
        ezsServiceIds.businessIdRestorationClassic,
    ];
    const isLostWallet = useAreServicesAndFeatureActive(ids, ["Product.Provide.VALUTFeature"]);

    const ensureDataFetched = (): any => {
        setisLoading(true);

        services
            .getLostWalletData()
            .then((lostWalletResponse) => {
                const response = lostWalletResponse["lost-wallet-response"];
                if (response) {
                    const decodedData = Common.decodeData(Common.decodeData(response));
                    setisLoading(false);
                    setUserLostWallets({
                        walletItemCreditCard: decodedData.walletItemCreditCard,
                        walletItemBankAccount: decodedData.walletItemBankAccount,
                        walletItemDriverLicence: decodedData.walletItemDriverLicence,
                        walletItemMedicalCard: decodedData.walletItemMedicalCard,
                        walletItemGenericIDs: decodedData.walletItemGenericIDs,
                        walletItemSSN: decodedData.walletItemSSN,
                        walletItemPassport: decodedData.walletItemPassport,
                        walletItemCustomerRewardCard: decodedData.walletItemCustomerRewardCard,
                        walletItemCombination: decodedData.walletItemCombination,
                        walletItemFamilyMembers: decodedData.walletItemFamilyMembers,
                    });
                }
            })
            .catch(function (error) {
                setisLoading(false);
            });
    };

    useEffect(() => {
        const initialUrl = window.location.origin + "/app/identity-vault";
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        ensureDataFetched();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const showAddWalletDialog = (): any => {
        setAddWalletDialogIsVisible(true);
    };

    const closeAddWalletDialog = (item: any): any => {
        setAddWalletDialogIsVisible(false);
        if (item) {
            setAddItemOption(item);
            showAddItemDialog();
        }
    };

    const showAddItemDialog = (): any => {
        setAddItemDialogIsVisible(true);
    };

    const closeAddItemDialog = (): any => {
        setAddItemDialogIsVisible(false);
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page">{tLang("identityVault.title")}</h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>
            <IdentityVaultTab selectedTab="2" />

            <div className="row" id="content">
                <div className="col-xs">
                    {isLostWallet && (
                        <div className="box offset-padding">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon" aria-hidden="true">
                                        <RenderIcons iconName="wallet" />
                                    </div>
                                    <div className="box-title-text">
                                        <h2 className="box-title">{tLang("identityVault.secureStorage.lostWallterWidget.title")}</h2>
                                    </div>
                                </div>
                                <div className="box-description">
                                    <p>{tLang("identityVault.secureStorage.lostWallterWidget.message")}</p>
                                </div>
                            </div>
                            <div className="box-content">
                                <div className="row between-xs margin-bottom-s">
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <h3 className="content-sub-title">{tLang("identityVault.secureStorage.lostWallterWidget.listTitle")}</h3>
                                    </div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <button type="button" className="btn-default btn-primary" id="btn-add-wallet-item" onClick={() => showAddWalletDialog()}>
                                            <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.addToWalletButtonText")}</span>
                                        </button>
                                    </div>
                                </div>

                                <div id="wallet-hider"></div>

                                {!isLoading ? (
                                    <>
                                        <div id="wallet-content" style={{ display: "block" }}>
                                            {userLostWallets &&
                                                (userLostWallets.walletItemCreditCard == null ||
                                                    (userLostWallets.walletItemCreditCard != null && userLostWallets.walletItemCreditCard.length < 1)) &&
                                                (userLostWallets.walletItemBankAccount == null ||
                                                    (userLostWallets.walletItemBankAccount != null && userLostWallets.walletItemBankAccount.length < 1)) &&
                                                (userLostWallets.walletItemDriverLicence == null ||
                                                    (userLostWallets.walletItemDriverLicence != null && userLostWallets.walletItemDriverLicence.length < 1)) &&
                                                (userLostWallets.walletItemMedicalCard == null ||
                                                    (userLostWallets.walletItemMedicalCard != null && userLostWallets.walletItemMedicalCard.length < 1)) &&
                                                (userLostWallets.walletItemGenericIDs == null ||
                                                    (userLostWallets.walletItemGenericIDs != null && userLostWallets.walletItemGenericIDs.length < 1)) &&
                                                (userLostWallets.walletItemSSN == null ||
                                                    (userLostWallets.walletItemSSN != null && userLostWallets.walletItemSSN.length < 1)) &&
                                                (userLostWallets.walletItemPassport == null ||
                                                    (userLostWallets.walletItemPassport != null && userLostWallets.walletItemPassport.length < 1)) &&
                                                (userLostWallets.walletItemCustomerRewardCard == null ||
                                                    (userLostWallets.walletItemCustomerRewardCard != null &&
                                                        userLostWallets.walletItemCustomerRewardCard.length < 1)) &&
                                                (userLostWallets.walletItemCombination == null ||
                                                    (userLostWallets.walletItemCombination != null && userLostWallets.walletItemCombination.length < 1)) &&
                                                (userLostWallets.walletItemFamilyMembers == null ||
                                                    (userLostWallets.walletItemFamilyMembers && userLostWallets.walletItemFamilyMembers.length < 1)) && (
                                                    <div className="msg-generic msg-small margin-top-xs">
                                                        <em className="las la-info-circle"></em>{" "}
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.noWalletItemMessage")}
                                                    </div>
                                                )}

                                            <div className="data-grid has-lines margin-top-s" id="lost-wallet-items-grid">
                                                {/* Credit card */}
                                                {userLostWallets && userLostWallets.walletItemCreditCard && (
                                                    <CreditDebitCard
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemCreditCards={[...userLostWallets.walletItemCreditCard]}
                                                    />
                                                )}

                                                {/* Bank Account */}
                                                {userLostWallets && userLostWallets.walletItemBankAccount && (
                                                    <BankAccount
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemBankAccounts={[...userLostWallets.walletItemBankAccount]}
                                                    />
                                                )}

                                                {/* Driver Licence */}
                                                {!isBusinessUser && userLostWallets && userLostWallets.walletItemDriverLicence && (
                                                    <DriversLicense
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemDriverLicences={[...userLostWallets.walletItemDriverLicence]}
                                                    />
                                                )}

                                                {/* Medical Id Card */}
                                                {!isBusinessUser && userLostWallets && userLostWallets.walletItemMedicalCard && (
                                                    <MedicalIdCard
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemMedicalCards={[...userLostWallets.walletItemMedicalCard]}
                                                    />
                                                )}

                                                {/* Id Card */}
                                                {!isBusinessUser && userLostWallets && userLostWallets.walletItemGenericIDs && (
                                                    <IdCard
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemGenericIDs={[...userLostWallets.walletItemGenericIDs]}
                                                    />
                                                )}

                                                {/* SSN */}
                                                {!isBusinessUser && userLostWallets && userLostWallets.walletItemSSN && (
                                                    <SocialSecurityCard
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemSSNs={[...userLostWallets.walletItemSSN]}
                                                    />
                                                )}

                                                {/* passport */}
                                                {userLostWallets && userLostWallets.walletItemPassport && (
                                                    <Passport
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemPassports={[...userLostWallets.walletItemPassport]}
                                                    />
                                                )}

                                                {/* Customer Rewards Card */}
                                                {userLostWallets && userLostWallets.walletItemCustomerRewardCard && (
                                                    <CustomerRewardsCard
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemCustomerRewardCards={[...userLostWallets.walletItemCustomerRewardCard]}
                                                    />
                                                )}

                                                {/* Combination */}
                                                {userLostWallets && userLostWallets.walletItemCombination && (
                                                    <Combination
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemCombinations={[...userLostWallets.walletItemCombination]}
                                                    />
                                                )}

                                                {/* Family Asset */}
                                                {userLostWallets && userLostWallets.walletItemFamilyMembers && (
                                                    <FamilyAsset
                                                        requestDataCallback={ensureDataFetched}
                                                        walletItemFamilyMembers={[...userLostWallets.walletItemFamilyMembers]}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="loading"></div>
                                )}
                            </div>
                        </div>
                    )}

                    <DocumentsAndImages />
                </div>
            </div>

            {/* Add Wallet modal*/}
            {addWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-add-wallet" title="Add Wallet" closeDialog={closeAddWalletDialog}>
                    <AddWalletDialog closeDialog={closeAddWalletDialog} />
                </DialogComponent>
            )}

            {/* Add Wallet Item modals*/}
            {addItemDialogIsVisible && addItemOption === "social-security-card" && (
                <DialogComponent dialogId="dialog-add-social-security-card-wallet" title="Add Social Security Card wallet" closeDialog={closeAddItemDialog}>
                    <SocialSecurityCardDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "passport" && (
                <DialogComponent dialogId="dialog-add-passport-wallet" title="Add passport wallet" closeDialog={closeAddItemDialog}>
                    <PassportDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "medical-id-card" && (
                <DialogComponent dialogId="dialog-add-medical-id-card-wallet" title="Add medical id card wallet" closeDialog={closeAddItemDialog}>
                    <MedicalIdCardDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "id-card" && (
                <DialogComponent dialogId="dialog-add-id-card-wallet" title="Add id card wallet" closeDialog={closeAddItemDialog}>
                    <IdCardDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "drivers-license" && (
                <DialogComponent dialogId="dialog-add-driver-license" title="Add Driver License wallet" closeDialog={closeAddItemDialog}>
                    <DriverLicenseDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "customer-rewards-card" && (
                <DialogComponent dialogId="dialog-add-customer-rewards-card" title="Add Customer Rewards Card wallet" closeDialog={closeAddItemDialog}>
                    <CustomerRewardsCardDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "credit-debit-card" && (
                <DialogComponent dialogId="dialog-add-credit-debit-card" title="Add Credit Debit Card wallet" closeDialog={closeAddItemDialog}>
                    <CreditDebitCardDialog
                        requestDataCallback={ensureDataFetched}
                        closeDialog={closeAddItemDialog}
                        walletItem={{ cardCategory: "CREDIT" }}
                        isNew={true}
                    />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "combination" && (
                <DialogComponent dialogId="dialog-add-combination" title="Add combination wallet" closeDialog={closeAddItemDialog}>
                    <CombinationDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}

            {addItemDialogIsVisible && addItemOption === "bank-account" && (
                <DialogComponent dialogId="dialog-add-bank-account" title="Add bank account wallet" closeDialog={closeAddItemDialog}>
                    <BankAccountDialog requestDataCallback={ensureDataFetched} closeDialog={closeAddItemDialog} walletItem={{}} isNew={true} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default SecureStorage;
